/* app/js/src/components/clipping-studio/panels/graphics-panel/mam-graphic-card/clipping-studio-mam-graphic-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  min-width: 0;
}
.mam-graphic-card {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  width: 100%;
  min-width: 0;
  padding: 8px 0;
  border-bottom: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  cursor: pointer;
  transition: background 0.15s ease;
}
.mam-graphic-card:last-child {
  border-bottom: none;
}
.mam-graphic-card:hover {
  background: rgba(0, 0, 0, 0.04);
}
.mam-graphic-card:hover .mam-graphic-card__add-btn {
  opacity: 1;
}
.mam-graphic-card__thumbnail {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 45px;
  overflow: hidden;
  background: rgba(35, 47, 58, 0.05);
}
.mam-graphic-card__img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.mam-graphic-card__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(35, 47, 58, 0.05);
}
.mam-graphic-card__placeholder-text {
  font-size: 10px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.mam-graphic-card__duration {
  position: absolute;
  left: 2px;
  bottom: 2px;
  padding: 2px 4px;
  font-size: 9px;
  letter-spacing: 0.1px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
}
.mam-graphic-card__info {
  flex: 1;
  min-width: 0;
  padding: 0 4px 0 0;
}
.mam-graphic-card__title {
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mam-graphic-card__duration-inline {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  margin-top: 2px;
}
.mam-graphic-card__edit-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(35, 47, 58, 0.8);
  color: #93a9bf;
  z-index: 3;
  opacity: 0;
  pointer-events: auto;
  transition: opacity 0.2s ease;
}
.mam-graphic-card__edit-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  cursor: pointer;
}
.mam-graphic-card--with-edit-overlay:hover .mam-graphic-card__edit-overlay {
  opacity: 1;
}
/*# sourceMappingURL=clipping-studio-mam-graphic-card.component.css.map */
